import React, { useEffect, useState, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { es } from "date-fns/locale";

import { PrivateRoute } from "./components/PrivateRoute.jsx";
import { NotFoundPage } from "./components/NotFoundPage.jsx";
import { ThemeConfig } from "./theme/ThemeConfig.jsx";
import storepersist from "./store";
import { Alert } from "./components";
import { clearCacheData, ClearSession } from "./utils";

import packageJson from "../package.json";

import { HomeLayout } from "./pages/home/HomeLayout.jsx";
import { LoginLayout } from "./pages/home/LoginLayout.jsx";
import LoginComponent from "./pages/login/LoginComponent";
import DashboardComponent from "./pages/dashboard/DashboardComponent";
import SelectProductComponent from "./pages/selectProduct/SelectProductComponent.js";
import PolicyComponent from "./pages/policy/PolicyComponent";
import DynamicFormComponent from "./pages/dynamicForm/DynamicFormComponent";
import ConfirmAccountFormComponent from "./pages/ConfirmAccount/ConfirmAccountFormComponent";
import OTPFormComponent from "./pages/OTP/OTPFormComponent";
import OTPEditDataComponent from "./pages/OTPEditData/OTPEditDataComponent";
import SummaryFormComponent from "./pages/summary/SummaryFormComponent";
import { PasswordRecoveryFormComponent } from "./pages/PasswordRecovery/PasswordRecoveryFormComponent";

import InformationalMessageFormComponent from "./pages/InformationalMessage/InformationalMessageFormComponent";
import InformationalMessage1FormComponent from "./pages/InformationalMessage1/InformationalMessage1FormComponent";
import DocumentSignComponent from "./pages/documentSign/DocumentSignComponent";
import CanvasPdfSignComponent from "./pages/documentSign/CanvasPdfSignComponent";
import CanvasPdfSignMasiveComponent from "./pages/documentSign/CanvasPdfSignMasiveComponent";
import EvidenceComponentHelp from "./pages/evidence/EvidenceComponentHelp";
import EvidenceComponent from "./pages/evidence/EvidenceComponent";
import CargarDocsComponent from "./pages/cargarDocs/CargarDocsComponent";
import DocumentCameraCapture from "./pages/camera/DocumentCameraCapture";
import BiometricsHelp from "./pages/biometrics/BiometricsHelp";
import CapturaIdentificacion from "./pages/validadocumentos/CapturaIdentificacion";
import ValidacionesExternas from "./pages/validadocumentos/ValidacionesExternas";
import RegisterComponent from "./pages/Product/RegisterComponent";
import OfertaCreditoFormComponent from "./pages/OfertaCredito/OfertaCreditoFormComponent";
import ConfirmComponent from "./pages/Product/ConfirmComponent";
import AboutComponent from "./pages/about/AboutComponent";
import DocListComponent from "./pages/docList/DocListComponent";
import DocumentViewerCheck from "./pages/documentSign/DocumentViewerCheck";
import IdentityDocumentSelectorComponent from "./pages/IdentityDocumentSelector/IdentityDocumentSelectorComponent";
import BioResultsComponent from "./pages/biometricResults/BioResultsComponent";
import SignHelp from "./pages/documentSign/SignHelp";
import SelectOptionsComponents from "./pages/selectOptions/SelectOptionsComponents";
import DocumentApprovalComponent from "./pages/documentApproval/DocumentApprovalComponent";
import SearchResultComponent from "./pages/searchResult/SearchResultComponent";
import CalculatorComponent from "./pages/creditQuote/CalculatorComponent";
import CreditOfferComponent from "./pages/creditQuote/CreditOfferComponent";
import CreditSelectionComponent from "./pages/creditQuote/CreditSelectionComponent";
import QrCodeComponent from "./pages/qrCode/QrCodeComponent.js";
import QrCloseProcess from "./pages/cargarDocs/QrCloseProcess.js";
import TransitionDocComponent from "./pages/qrCode/TransitionDocComponent.js";
import MobileCamaraCapture from "./pages/cargarDocs/MobileCamaraCapture.js";
import FormWebCamera from "./pages/camera/FormWebCamera.js";
import IdentityValidationComponent from "./pages/IdentityValidation/IdentityValidationComponent.js";
import IdentityValCamera from "./pages/IdentityValidation/IdentityValCamera.js";
import HelpSelfie from "./pages/IdentityValidation/HelpSelfie.js";
import Carousel from "./pages/IdentityValidation/Carousel.js";
// import ExtractionForm from './pages/IdentityValidation/ExtractionForm.js'
import { ExtractionForm } from "./pages/IdentityValidation/ExtractionForm.js";
import FingerSelectCapture from "./pages/IdentityValidation/FingerSelectCapture.js";
import SkipJustification from "./pages/IdentityValidation/SkipJustification.js";
import ExternalValidations from "./pages/IdentityValidation/ExternalValidations.js";
import SearchGroupComponent from "./pages/groupActors/SearchGroupComponent.js";
import CreateGroupComponent from "./pages/groupActors/CreateGroupComponent.js";
import GroupActorsComponent from "./pages/groupActors/GroupActorsComponent.js";
import EditActorsComponent from "./pages/groupActors/EditActorsComponent.js";
import FirmaEA from "./pages/FirmaEA/FirmaEAFormComponent.js";
import FirmaEAFormComponent from "./pages/FirmaEA/FirmaEAFormComponent.js";
import EvidenceStartComponent from "./pages/evidence/EvidenceStartComponent";
import EvidenceAudioComponent from "./pages/evidence/EvidenceAudioComponent";
import LocationEAudioComponent from "./pages/evidence/LocationEAudioComponent";
import CollectionManagementFormComponent from "./pages/CollectionManagement/CollectionManagementFormComponent";
import FinishColManagementFormComponent from "./pages/CollectionManagement/FinishColManagementFormComponent";
import FirmaClaveComponent from "./pages/FirmaEA/FirmaClaveComponent";
import HelpFingertComponent from "./pages/IdentityValidation/HelpFingertComponent";
import FingersCaptureComponent from "./pages/IdentityValidation/FingersCaptureComponent";
import HelpHandsComponent from "./pages/IdentityValidation/HelpHandsComponent";
import SkipJustificationMinutiae from "./pages/IdentityValidation/SkipJustificationMinutiae.js";
import SkipJustificationHand from "./pages/IdentityValidation/SkipJustificationHand.js";
import CreditSimulatorComponent from "./pages/creditSimulator/CreditSimulatorComponent";
import LifeTestComponent from "./pages/LifeTest/LifeTestComponent";
import IndexComponent from "./pages/Index/IndexComponent";
// import MicroblinkCamera from './pages/IdentityValidation/MicroblinkCamera'
import MicroblinkCamera from "./pages/Microblick/MicroblinkCamera";
import ConfirmFinalizeComponent from "./pages/Product/ConfirmFinalizeComponent";
import IndexExternalComponent from "./pages/IndexExternal/IndexExternalComponent";
import LifeTestHelp from "./pages/LifeTest/LifeTestHelp";
import DocumentViewerCheckCarrusel from "./pages/documentSign/DocumentViewerCheckCarrusel";
import StartFlowWithoutLoginComponent from "./pages/StartFlowWithoutLogin/StartFlowWithoutLoginComponent";

import AdvancedSignature from "./pages/AdvancedSignature/SignFEA.js";
import RecoverPasswordComponentLego from "./pages/recoverPassword/RecoverPasswordComponentLego.js";
import WelcomePortal from "./pages/login/WelcomePortal.js";
import "./assets/Tipografias/MetLifeCircular-Medium.otf";
import { msalConfig } from "./msalConfig.js";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import useIdleTimer from "./components/useIdleTimer.jsx";
import { setupAxiosInterceptors } from "middlewares/axiosMiddleware.js";
import PreRegister from "./pages/PreRegister/index.jsx";
import SignFEAViewerCheckCarrusel from './pages/AdvancedSignature/SignFEAViewerCheckCarrusel.js';
import SatisfactionSurveyComponent from "./pages/SatisfactionSurvey/index.jsx";

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const { store, persistor } = storepersist;
  const [online, setOnline] = useState(navigator.onLine);

  const handleIdle = () => {
    // Cerrar sesión o redirigir a la página de login
    Alert(
      {
        icon: "error",
        title: "Has sido desconectado por inactividad.",
      },
      (event) => {
        ClearSession();
        window.location.reload();
      }
    );
    // persistor.EndSession();
    // Aquí puedes limpiar cualquier estado global o sesión
    // navigateNext("/auth/");
  };

  useIdleTimer(handleIdle, 43200000); // 300000 ms = 5 minutos, 600000 = 10 minutos, 900000 = 15 minutos
                          //12hrs
  //useEffect(() => {
  //  // Obtén la URL del archivo CSS desde la variable de entorno
  //  const cssUrl = process.env.REACT_APP_URL_FONTS;
  //
  //  // Crea un elemento link para importar el archivo CSS
  //  const link = document.createElement('link');
  //  link.rel = 'stylesheet';
  //  link.href = cssUrl;
  //
  //  // Agrega el elemento link al head del documento
  //  document.head.appendChild(link);
  //
  //  // Limpia el elemento link al desmontar el componente
  //  return () => {
  //    document.head.removeChild(link);
  //  };
  //}, []);

  useEffect(() => {
    localStorage.setItem("inicioApp", "inicio");
    caching();
    setupAxiosInterceptors();
  }, []);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    // console.log("online: ", online, localStorage?.getItem('inicioApp'))
    if (online && localStorage?.getItem("inicioApp") === "continue") {
      Alert({
        icon: "success",
        title: "Se restauró la conexión a internet.",
      });
      localStorage.setItem("inicioApp", "inicio");
      window.location.reload();
    } else if (localStorage?.getItem("inicioApp") === "inicio" && !online) {
      Alert({
        icon: "error",
        title: "En este momento no tienes conexión",
      });
      localStorage.setItem("inicioApp", "continue");
    }
  }, [online]);

  let caching = () => {
    let version = localStorage?.getItem("versionApp");
    // console.log("version: ", version)
    // console.log(" packageJson.version: ", packageJson.version)
    if (version != packageJson.version) {
      if ("caches" in window) {
        clearCacheData().catch((error) => {
          console.error("Caught an error:", error);
        });
        window.location.reload(true);
      }

      localStorage.clear();
      localStorage.setItem("versionApp", packageJson.version);
    }
  };

  return (
    <Suspense fallback="loading">
      <BrowserRouter
        basename={
          process.env.NODE_ENV == "development"
            ? "/"
            : `${process.env.REACT_APP_BASENAME}`
        }
      >
        <Provider store={store}>
          <PersistGate loading="null" persistor={persistor}>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={es}
            >
              <ThemeConfig>
                <MsalProvider instance={msalInstance}>
                  <Routes>
                    <Route path="/Register" element={<PreRegister />} />
                    <Route path="/auth" element={<LoginLayout />}>
                      <Route index element={<Navigate to="login" />} />
                      <Route path="login" element={<LoginComponent />} />
                      <Route
                        path="RegisterComponent"
                        element={<RegisterComponent />}
                      />
                      <Route
                        path="StartFlowWithoutLogin"
                        element={<StartFlowWithoutLoginComponent />}
                      />
                      <Route
                        path="ConfirmFinalizeComponent"
                        element={<ConfirmFinalizeComponent />}
                      />
                      <Route
                        path="CreditSimulatorComponent"
                        element={<CreditSimulatorComponent />}
                      />
                      <Route
                        path="ConfirmComponent"
                        element={<ConfirmComponent />}
                      />
                      <Route
                        path="PasswordRecovery"
                        element={<PasswordRecoveryFormComponent />}
                      />
                      <Route path="QrCode" element={<QrCodeComponent />} />
                      <Route
                        path="ConfirmAccountComponent"
                        element={<ConfirmAccountFormComponent />}
                      />
                    </Route>
                    <Route path="/" element={<PrivateRoute />}>
                      <Route index element={<Navigate to="main" />} />
                      <Route path="main" element={<HomeLayout />}>
                        <Route
                          path="DashboardComponent"
                          element={<DashboardComponent />}
                        />
                        <Route
                          path="SelectProductComponent"
                          element={<SelectProductComponent />}
                        />
                        <Route
                          path="IdentityDocumentSelectorComponent"
                          element={<IdentityDocumentSelectorComponent />}
                        />
                        <Route
                          path="OTPEditData"
                          element={<OTPEditDataComponent />}
                        />
                        <Route
                          path="OTPComponent"
                          element={<OTPFormComponent />}
                        />
                        <Route
                          path="PolicyComponent"
                          element={<PolicyComponent />}
                        />
                        <Route
                          path="DynamicQuestionary"
                          element={<DynamicFormComponent />}
                        />
                        <Route
                          path="SatisfactionSurvey"
                          element={<SatisfactionSurveyComponent />}
                        />
                        <Route
                          path="DocumentSignComponent"
                          element={<DocumentSignComponent />}
                        />
                        <Route
                          path="CanvasPdfSignComponent"
                          element={<CanvasPdfSignComponent />}
                        />
                        <Route
                          path="CanvasPdfSignMasiveComponent"
                          element={<CanvasPdfSignMasiveComponent />}
                        />
                        <Route
                          path="CargarDocsComponent"
                          element={<CargarDocsComponent />}
                        />
                        <Route
                          path="EvidenceComponent"
                          element={<EvidenceComponent />}
                        />
                        <Route
                          path="EvidenceComponentHelp"
                          element={<EvidenceComponentHelp />}
                        />
                        <Route
                          path="SummaryComponent"
                          element={<SummaryFormComponent />}
                        />
                        <Route
                          path="DocumentCameraCapture"
                          element={<DocumentCameraCapture />}
                        />
                        <Route
                          path="validaCaptura"
                          element={<CapturaIdentificacion />}
                        />
                        <Route
                          path="BiometricsHelp"
                          element={<BiometricsHelp />}
                        />
                        <Route
                          path="validaExternas"
                          element={<ValidacionesExternas />}
                        />
                        <Route
                          path="InformationalMessageComponent"
                          element={<InformationalMessageFormComponent />}
                        />
                        <Route
                          path="InformationalMessage1Component"
                          element={<InformationalMessage1FormComponent />}
                        />
                        <Route
                          path="OfertaCreditoFormComponent"
                          element={<OfertaCreditoFormComponent />}
                        />
                        <Route
                          path="AboutComponent"
                          element={<AboutComponent />}
                        />
                        <Route
                          path="DocListComponent"
                          element={<DocListComponent />}
                        />
                        <Route
                          path="BioResultsComponent"
                          element={<BioResultsComponent />}
                        />
                        <Route
                          path="DocumentViewerCheck"
                          element={<DocumentViewerCheck />}
                        />
                        <Route path="SignHelp" element={<SignHelp />} />
                        <Route
                          path="SelectOptionsComponents"
                          element={<SelectOptionsComponents />}
                        />
                        <Route
                          path="DocumentApprovalComponent"
                          element={<DocumentApprovalComponent />}
                        />
                        <Route
                          path="CalculatorComponent"
                          element={<CalculatorComponent />}
                        />
                        <Route
                          path="CreditOfferComponent"
                          element={<CreditOfferComponent />}
                        />
                        <Route
                          path="CreditSelectionComponent"
                          element={<CreditSelectionComponent />}
                        />
                        <Route
                          path="TransitionDocComponent"
                          element={<TransitionDocComponent />}
                        />
                        <Route
                          path="FormWebCamera"
                          element={<FormWebCamera />}
                        />
                        <Route
                          path="MobileCamaraCapture"
                          element={<MobileCamaraCapture />}
                        />
                        <Route
                          path="IdentityValidationComponent"
                          element={<IdentityValidationComponent />}
                        />
                        <Route
                          path="IdentityValCamera"
                          element={<IdentityValCamera />}
                        />
                        <Route path="HelpSelfie" element={<HelpSelfie />} />
                        <Route path="Carousel" element={<Carousel />} />
                        <Route
                          path="ExtractionForm"
                          element={<ExtractionForm />}
                        />
                        <Route
                          path="FingerSelectCapture"
                          element={<FingerSelectCapture />}
                        />
                        <Route
                          path="SkipJustification"
                          element={<SkipJustification />}
                        />
                        <Route
                          path="ExternalValidations"
                          element={<ExternalValidations />}
                        />
                        <Route
                          path="SearchGroupComponent"
                          element={<SearchGroupComponent />}
                        />
                        <Route
                          path="CreateGroupComponent"
                          element={<CreateGroupComponent />}
                        />
                        <Route
                          path="GroupActorsComponent"
                          element={<GroupActorsComponent />}
                        />
                        <Route
                          path="EditActorsComponent"
                          element={<EditActorsComponent />}
                        />
                        <Route
                          path="FirmaEA"
                          element={<FirmaEAFormComponent />}
                        />
                        <Route
                          path="QrCloseProcess"
                          element={<QrCloseProcess />}
                        />
                        <Route
                          path="SearchResultComponent"
                          element={<SearchResultComponent />}
                        />
                        <Route
                          path="EvidenceStartComponent"
                          element={<EvidenceStartComponent />}
                        />
                        <Route
                          path="EvidenceAudioComponent"
                          element={<EvidenceAudioComponent />}
                        />
                        <Route
                          path="CollectionManagementComponent"
                          element={<CollectionManagementFormComponent />}
                        />
                        <Route
                          path="LocationEAudioComponent"
                          element={<LocationEAudioComponent />}
                        />
                        <Route
                          path="FinishColManagementFormComponent"
                          element={<FinishColManagementFormComponent />}
                        />
                        <Route
                          path="FirmaClaveComponent"
                          element={<FirmaClaveComponent />}
                        />
                        <Route
                          path="HelpFingertComponent"
                          element={<HelpFingertComponent />}
                        />
                        <Route
                          path="FingersCaptureComponent"
                          element={<FingersCaptureComponent />}
                        />
                        <Route
                          path="HelpHandsComponent"
                          element={<HelpHandsComponent />}
                        />
                        <Route
                          path="SkipJustificationHand"
                          element={<SkipJustificationHand />}
                        />
                        <Route
                          path="SkipJustificationMinutiae"
                          element={<SkipJustificationMinutiae />}
                        />
                        <Route
                          path="LifeTestComponent"
                          element={<LifeTestComponent />}
                        />
                        <Route
                          path="MicroblinkCamera"
                          element={<MicroblinkCamera />}
                        />
                        <Route path="LifeTestHelp" element={<LifeTestHelp />} />
                        <Route
                          path="DocumentViewerCheckCarrusel"
                          element={<DocumentViewerCheckCarrusel />}
                        />
                        <Route
                          path="AdvancedSignViewer"
                          element={<SignFEAViewerCheckCarrusel />}
                        />
                        <Route
                          path="AdvancedSignature"
                          element={<AdvancedSignature />}
                        />
                        <Route
                          path="RecoverPasswordComponentLego"
                          element={<RecoverPasswordComponentLego />}
                        />
                        <Route
                          path="WelcomePortal"
                          element={<WelcomePortal />}
                        />
                      </Route>
                      {/* <Route path="unAuthenticated" element={<UnAuthenticated />} />
                    <Route path="unAuthenticated?ActionId=idStage&?view=idView" element={<UnAuthenticated />} /> */}
                      <Route path="*" element={<Navigate to="404" />} />
                      <Route path="/auth/login" element={<LoginComponent />} />
                      <Route path="404" element={<NotFoundPage />} />
                    </Route>
                  </Routes>
                </MsalProvider>
              </ThemeConfig>
            </LocalizationProvider>
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
